/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type ApiUsageLogListServiceName =
  (typeof ApiUsageLogListServiceName)[keyof typeof ApiUsageLogListServiceName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiUsageLogListServiceName = {
  claude: "claude",
  kling: "kling",
  openai: "openai",
  suno: "suno",
  youtube: "youtube",
} as const;
